import ReadingIcon from './ReadingIcon'

export default ReadingIcon
